import * as React from "react";
import type { SVGProps } from "react";
const SvgIconChatQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_6117_4501)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.9.82C1.9.96 1.1 1.69.86 2.69l-.06.2v14.26l.07.24c.24.88.89 1.52 1.79 1.77.18.05.23.05 1.55.06h1.36v1.6c0 1.35 0 1.63.03 1.75.14.5.7.78 1.18.56.07-.04 1.08-.83 2.52-1.98l2.4-1.93h4.63c3.97 0 4.67 0 4.84-.03.95-.17 1.7-.86 1.96-1.8l.07-.24V2.89l-.06-.2c-.23-.92-.9-1.58-1.82-1.83L21.13.8h-9.05C7.11.8 2.98.8 2.9.82m.12 1.72c-.16.05-.35.22-.44.39-.05.08-.05.3-.05 7.08v7l.05.09q.13.22.37.35l.13.06 1.8.01c1.77.01 1.78.01 1.9.06.2.1.4.32.48.55.01.05.03.53.03 1.24l.02 1.17 1.8-1.44c.99-.8 1.85-1.47 1.92-1.5l.12-.07 4.88-.01 4.89-.01.13-.06c.15-.08.3-.21.37-.35l.05-.1V3.01l-.05-.1c-.07-.1-.23-.27-.35-.33-.08-.05-.36-.05-9.03-.05zm8.44 1.48c-.26.04-.67.18-.9.3q-.97.5-1.47 1.48c-.23.45-.32.82-.32 1.32 0 .31 0 .34.07.46q.13.28.42.42c.13.06.18.07.35.07s.22 0 .35-.07c.32-.15.47-.38.5-.78.04-.31.08-.5.17-.67q.31-.61.98-.8c.19-.06.59-.06.79 0q.7.22 1 .86c.13.3.16.72.07 1.02-.1.3-.19.45-.4.66-.3.3-.54.4-1.01.46s-.68.18-.84.51l-.07.16v.98c0 1.1 0 1.08.17 1.31.09.13.28.27.42.31.12.04.4.04.52 0 .14-.04.33-.18.42-.3.15-.21.17-.28.18-.85v-.51l.18-.06c.41-.14.9-.44 1.23-.76.49-.48.82-1.13.94-1.8.05-.33.03-.88-.04-1.2-.2-.94-.8-1.72-1.64-2.18-.58-.32-1.4-.45-2.07-.34m.21 9.55q-.3.08-.55.34c-.26.26-.37.51-.37.87 0 .64.45 1.16 1.08 1.25.53.07 1.05-.2 1.3-.68.17-.35.16-.8-.02-1.15-.08-.15-.36-.44-.52-.53-.26-.13-.64-.17-.92-.1"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6117_4501">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconChatQuestion;
